<template>
  <div id="dialog-boardView">

    <dialog_boardEdit v-if="postEditorVisible" :thePost="thePost" :windowOnOff="showEditor" :reloadPost="updateViewingPost" />
    
    <div class="read-board">

      <div class="header">
        <p @click="windowOnOff(false)"><i class="ph-bold ph-arrow-left"></i></p>
        <h2>글 보기</h2>
        <p style="opacity:0;"><i class="ph-bold ph-dots-three"></i></p>
      </div>

      <div id="post">
        <div class="header">
          <img :src="thumb" alt="Thumbnail" class="thumb" />
          <div class="cover">
            <p class="type">{{getBoardNameById(thePost.category_id)}}</p>
            <div class="index">
              <h2>{{ title }}</h2>
              <ul v-if="isManager">
                <li v-on:click="deletePost(thePost.idx)"><i class="ph ph-trash"></i> </li>
                <li v-on:click="editPost()"><i class="ph ph-pencil-line"></i> </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="content"> <div id="editorjsView"></div> </div>


        <!-- 좋아요 수집 -->
        <div class="like-collection">
          <button :class="{'liked': im_liked}" @click="LikeClick()">
            <i v-if="im_liked" class="ph-fill ph-heart"></i>
            <i v-if="!im_liked" class="ph ph-heart"></i>
            {{ post_likes }}
          </button>
          <span>좋아요</span>
        </div>

        <!-- 인쇄 버튼 -->
        <div class="print-button-wrapper">
          <button @click="printPost" class="print-button">
            <i class="ph ph-printer"></i>
            인쇄하기
          </button>
        </div>

        <div class="related-posts" v-if="relatedPosts.length > 0">
        <h3>관련 글</h3>
        <div class="related-posts-scroll">
          <div 
            class="related-post-card" 
            v-for="post in relatedPosts" 
            :key="post.idx"
            @click="openRelatedPost(post)"
          >
            <div class="related-thumb">
              <img :src="post.thumb || '/imgs/empty_image.png'" alt="" />
            </div>
            <div class="related-info">
              <p class="related-title">{{ post.title }}</p>
              <span class="related-date">{{ formatDate(post.created_at) }}</span>
            </div>
          </div>
        </div>
      </div>
        
        <fragment_commentView :target_table="'board_reference'" :target_id="thePost.idx"></fragment_commentView>
      </div>

    </div>

  </div>
</template>


<script>
import { inject, ref, onMounted } from "vue"

import dialog_boardEdit from "./boardEdit.vue"

import fragment_commentView from "@/components/fragments/commentView.vue"

import EditorJS from '@editorjs/editorjs'
import Header from '@editorjs/header'
import ImageTool from '@editorjs/image'
import List from '@editorjs/list'
import Attaches from '@editorjs/attaches'

import { useBackButton } from '@/utils/useBackBtn';

export default {
  components: {
    dialog_boardEdit,
    fragment_commentView
  },
  props:{
    thePost: Object,
    windowOnOff: Function,
    reloadPost: { type: Function, default: () => {} },
  },
  setup(props) {
    const sql_query = inject('sql_query');
    const getMbid = inject('getMbid');
    const member_info = inject('member_info'); // setup 상단에 추가
    const viewing_post = ref({ ...props.thePost });
    const post_likes = ref(0);
    const im_liked = ref(false);
    
    
    useBackButton(() => {
      props.windowOnOff(false);
    });

    async function updateViewingPost() {
      props.reloadPost();
      if (viewing_post.value) {
        let res = await sql_query("select * from board_reference where idx = " + viewing_post.value.idx);
        viewing_post.value = { ...res[0] };
        savedData.value = viewing_post.value.content ? JSON.parse(viewing_post.value.content) : {};
        thumb.value = viewing_post.value.thumb ? viewing_post.value.thumb : '/imgs/empty_image.png';
        title.value = viewing_post.value.title;
        settingEDJS();
      } else {
        props.windowOnOff(false);
      }
    }

    const board_list = ref([]);

    async function fetchBoards() {
      const result = await sql_query(" select * from board_category order by sort_order asc ");
      if (result && result.length > 0) {
        board_list.value = result;
      }
    }
    fetchBoards();

    function getBoardNameById(boardId) {
      const board = board_list.value.find(b => b.idx === boardId);
      return board ? board.name : "";
    }

    const editor = ref(null);
    const savedData = ref(null);
    const title = ref('');
    const thumb = ref('');
    const isManager = ref(false);

    const postEditorVisible = ref(false);
    const postEditorItem = ref(null);

    function editPost() {
      postEditorVisible.value = true;
      postEditorItem.value = props.thePost;
    }

    function showEditor(b) {
      postEditorVisible.value = b;
    }
  
    async function deletePost(idx) {
      if (!confirm("정말로 삭제하시겠습니까?")) {
        return;
      }
      await sql_query(`DELETE FROM board_reference WHERE idx = ${idx}`);
      props.reloadPost();
      props.windowOnOff(false);
    }

    async function settingEDJS() {
      if (editor.value) {
        editor.value.destroy();
      }
      try {
        let response = viewing_post.value;

        savedData.value = response.content ? JSON.parse(response.content) : {};
        thumb.value = response.thumb ? response.thumb : '/imgs/empty_image.png';
        title.value = response.title;

        if (response.mb_id == getMbid() || member_info.level <= 1) {
          isManager.value = true;
        }
        
        editor.value = new EditorJS({
          holder: 'editorjsView',
          placeholder: '글이 없습니다.',
          autofocus: true,
          readOnly: true,
          data: savedData.value,
          tools: {
            header: { class: Header, toolbox: { title: '제목' } },
            list: { class: List, toolbox: { title: '리스트' } },
            image: { class: ImageTool },
            attaches: { class: Attaches },
          },
          onReady: () => {
            console.log('Editor.js가 초기화되었습니다.');
          },
          i18n: {
            messages: {
              ui: {
                "blockTunes": { "toggler": { "Click to tune": "클릭하여 조정", "or drag to move": "또는 드래그하여 이동" }, },
                "inlineToolbar": { "converter": { "Convert to": "변환하기" } },
                "toolbar": { "toolbox": { "Add": "추가" } }
              },
              toolNames: {
                "Text": "문단",
                "Heading": "제목",
                "List": "목록",
                "Warning": "경고",
                "Checklist": "체크리스트",
                "Attachment": "첨부 파일",
                "Unordered List": "점 목록",
                "Ordered List": "숫자 목록",
                "Quote": "인용",
                "Code": "코드",
                "Image": "사진",
                "Delimiter": "구분 기호",
                "Raw HTML": "HTML코드",
                "Table": "표",
                "Link": "링크",
                "Marker": "마커",
                "Bold": "굵게",
                "Italic": "이탤릭",
                "InlineCode": "인라인 코드",
              },
              tools: {
                "warning": { "Title": "제목", "Message": "메시지", },
                "link": { "Add a link": "링크를 추가" },
                "stub": { 'The block can not be displayed correctly.': '블록을 올바르게 표시할 수 없습니다.' }
              },
              blockTunes: {
                "delete": { "Delete": "삭제" },
                "moveUp": { "Move up": "위로" },
                "moveDown": { "Move down": "아래로" }
              },
            }
          },
        });
        
      } catch (error) {
        console.error("게시물 조회 실패:", error);
      }
    }

    function LikeClick() {
      if (im_liked.value) {
        post_likes.value -= 1;
        im_liked.value = false;
        sql_query(`delete from likes where target_idx = ${viewing_post.value.idx} and mb_id = '${getMbid()}'`);
      } else {
        post_likes.value += 1;
        im_liked.value = true;
        sql_query(`insert into likes set target_table = 'board_reference', target_idx = ${viewing_post.value.idx}, mb_id = '${getMbid()}'`);
      }
    }

    async function fetchLikes() {
      const mb_id = getMbid();
      const post_id = viewing_post.value.idx;

      const sql = `
        SELECT COUNT(*) AS cnt 
        FROM likes 
        WHERE target_table = 'board_reference' 
          AND target_idx = ${post_id};
      `;

      const mineSql = `
        SELECT 1 
        FROM likes 
        WHERE target_table = 'board_reference' 
          AND target_idx = ${post_id} 
          AND mb_id = '${mb_id}' 
        LIMIT 1;
      `;

      const [allLikes, myLike] = await Promise.all([
        sql_query(sql),
        sql_query(mineSql)
      ]);

      post_likes.value = allLikes?.[0]?.cnt || 0;
      im_liked.value = myLike.length > 0;
    }

    function printPost() {
      const style = document.createElement('style');
      style.id = 'print-style-override';
      style.textContent = `
        @media print {
          @page {
            size: A4 portrait;
            margin: 0;
          }
        }
      `;
      document.head.appendChild(style);

      window.print();

      setTimeout(() => {
        const styleEl = document.getElementById('print-style-override');
        if (styleEl) {
          styleEl.remove();
        }
      }, 1000);
    }

    // 관련 글
    const relatedPosts = ref([]);

    async function fetchRelatedPosts() {
      const currentIdx = viewing_post.value.idx;
      const categoryId = viewing_post.value.category_id;
      
      const sql = `
        SELECT idx, title, thumb, created_at 
        FROM board_reference 
        WHERE category_id = ${categoryId} 
          AND idx != ${currentIdx}
        ORDER BY created_at DESC 
        LIMIT 5
      `;
      
      const result = await sql_query(sql);
      relatedPosts.value = result || [];
    }

    function formatDate(dateStr) {
      if (!dateStr) return '';
      const date = new Date(dateStr);
      return `${date.getFullYear()}.${String(date.getMonth() + 1).padStart(2, '0')}.${String(date.getDate()).padStart(2, '0')}`;
    }

    async function openRelatedPost(post) {
      // 전체 게시글 데이터 가져오기
      const result = await sql_query(`SELECT * FROM board_reference WHERE idx = ${post.idx}`);
      if (result && result.length > 0) {
        viewing_post.value = { ...result[0] };
        settingEDJS();
        fetchLikes();
        fetchRelatedPosts();
        // 스크롤 맨 위로
        document.getElementById('post')?.scrollTo(0, 0);
      }
    }

    onMounted(async () => {
      settingEDJS();
      fetchLikes();
      fetchRelatedPosts();
    });

    return {
      editor,
      title,
      thumb,
      deletePost,
      editPost,
      isManager,
      postEditorVisible,
      showEditor,
      viewing_post,
      updateViewingPost,
      getBoardNameById,
      post_likes,
      LikeClick,
      im_liked,
      printPost,
      relatedPosts,
      formatDate,
      openRelatedPost
    }
  }
}
</script>


<style scoped>
#dialog-boardView {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: start;
  align-items: center;
  flex-direction: column;
  background-color: var(--color-background);
  z-index: 99;
}

.read-board {
  width: 100%;
  height: 100%;
  overflow: hidden;
  width:100%;
  height: fit-content;
  display:flex;
  flex-direction: column;
  align-items: center;
}

.read-board > .header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 60px;
  color: var(--color-text-primary);
  padding: 16px;
  box-sizing: border-box;
}

.read-board > .header > p {
  aspect-ratio: 1/1;
  background: none;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: var(--color-text-primary);
  font-size: var(--font-size-xl);
  cursor: pointer;
  margin:0;
  padding:0;
}

.read-board > .header > h2 {
  font-size: var(--font-size-xl);
  color: var(--color-text-primary);
  margin:0;
  padding:0;
}




#post {
  position: relative;
  width: 100%;
  /* max-width: var(--break-point-mobile); */
  display:flex;
  flex-direction: column;
  margin: 0 auto;
  gap:48px;
  overflow: scroll;
}

#post::-webkit-scrollbar {
  display: none;
}

@media (max-width: 768px) {
  #post {
    max-width: 600px;
    padding:16px;
    box-sizing: border-box;
  }
}

#post .header {
  display: flex;
  flex-direction: column;
  justify-content: end;
  border-bottom: 1px solid var(--color-text-secondary);
  min-height: 400px;
  height: 400px;
  background: var(--color-text-secondary);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  overflow: hidden;
  position: relative;
}

#post .header > .thumb {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  background: var(--color-text-secondary);
  border-radius: 0px;
}

#post .header > .cover {
  position: absolute;
  z-index: 99;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-items: center;
  height: 100%;
  background: rgba(0,0,0,0.6);
  padding: 12px;
  box-sizing: border-box;
}

#post .header > .cover > p {
  width: 100%;
  background: none;
  border: none;
  margin:0;
  font-size:16px;
  max-width: var(--break-point-mobile);
}

#post .header > .cover > .index {
  display:flex;
  height:60px;
  width: 100%;
  max-width: var(--break-point-mobile);
}

#post .header > .cover > .index > h2 {
  width: 100%;
  background: none;
  border: none;
  margin:0;
  font-size:48px;
  color:#fff;
  font-weight: 700;
  overflow: hidden;
}

#post .header > .cover > .index > ul {
  display: flex;
  list-style: none;
  display: flex;
  justify-content: center;
  align-items: center;
  margin:0;
  padding:0;
}

#post .header > .cover > .index > ul > li {
  width:48px;
  height:48px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  cursor: pointer;
  color:#fff;
}

#post .header > .cover > .index > ul > li > label {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  cursor: pointer;
}

#post .content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

#post .content > #editorjsView {
  width: 100%;
  height:fit-content;
  color:var(--color-text-primary) !important;
  max-width: var(--break-point-mobile);
  overflow:hidden;
}

#post #saveBtn { 
  position: absolute;
  right: 0px;
  bottom: 24px;
  padding: 12px 24px;
  background: var(--color-brand);
  margin:0;
  border-radius: 24px;
  cursor: pointer;
  z-index: 9;
}

.like-collection {
  width:100%;
  display:Flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap:8px;
  margin-bottom: 48px;
}

.like-collection > button {
  width:70px;
  height:70px;
  border-radius: 12px;
  border: none;
  background: var(--color-background-light);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap:2px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text-primary);
  padding:0;
  margin:0;
}

.like-collection > button > i {
  font-size:32px;
}

.like-collection > button.liked {
  background: var(--color-brand);
  color: #fff;
}

.print-button-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 48px;
}

.print-button {
  padding: 14px 32px;
  border-radius: 12px;
  border: 2px solid var(--color-text-secondary);
  background: var(--color-background);
  color: var(--color-text-primary);
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease;
}

.print-button:hover {
  background: var(--color-background-light);
  border-color: var(--color-text-primary);
  transform: translateY(-2px);
}

.print-button > i {
  font-size: 20px;
}
</style>




<style>
.ce-popover-item {
  transition: all 0.2s ease-out;
}
.ce-popover-item:hover {
  padding-left:12px;
}

.ce-toolbar__actions,
.ce-toolbar__actions * {
  font-size: 14px;
  color: var(--color-text-primary) !important;
  background: var(--color-primary) !important;
  border: none;
}

.ce-popover__container {
  border: solid 1px var(--color-text-secondary);
  background: var(--color-primary) !important;
}

.ce-block__content {
  max-width: 100% !important;
}
.ce-toolbar__content {
  max-width: 100% !important;
  color:var(--color-text-primary) !important;
}
.cdx-attaches.cdx-attaches--with-file {
  background: var(--color-background);
  border: 1px solid var(--color-text-secondary);
}
.cdx-attaches__download-button {
  background: var(--color-background-light) !important;
}
.codex-editor path {
  stroke: var(--color-text-primary) !important;
}

/* 관련 글 */
.related-posts {
  width: 100%;
  max-width: var(--break-point-mobile);
  margin: 0 auto 48px;
  padding: 0 16px;
  box-sizing: border-box;
}

.related-posts > h3 {
  font-size: 18px;
  font-weight: 700;
  color: var(--color-text-primary);
  margin: 0 0 16px 0;
}

.related-posts-scroll {
  display: flex;
  gap: 12px;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 8px;
}

.related-posts-scroll::-webkit-scrollbar {
  height: 4px;
}

.related-posts-scroll::-webkit-scrollbar-track {
  background: var(--color-background-light);
  border-radius: 2px;
}

.related-posts-scroll::-webkit-scrollbar-thumb {
  background: var(--color-text-secondary);
  border-radius: 2px;
}

.related-post-card {
  flex: 0 0 160px;
  scroll-snap-align: start;
  background: var(--color-background-light);
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.related-post-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.related-thumb {
  width: 100%;
  aspect-ratio: 16 / 10;
  overflow: hidden;
  background: var(--color-text-secondary);
}

.related-thumb > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.related-info {
  padding: 12px;
}

.related-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text-primary);
  margin: 0 0 6px 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.4;
}

.related-date {
  font-size: 12px;
  color: var(--color-text-secondary);
}

/* ==================== 인쇄 스타일 ==================== */
@media print {
  /* HTML, Body 높이 제한 제거 */
  html, body {
    height: auto !important;
    overflow: visible !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  .related-posts {
    display: none !important;
  }

  /* 불필요한 UI 요소 숨김 */
  .read-board > .header,
  #post .header > .cover > .index > ul,
  .like-collection,
  .print-button-wrapper,
  fragment_commentView,
  [class*="comment"],
  [id*="comment"] {
    display: none !important;
  }

  /* 기본 레이아웃 재설정 */
  #dialog-boardView {
    position: static !important;
    height: auto !important;
    min-height: auto !important;
    max-height: none !important;
    background: white !important;
    overflow: visible !important;
  }

  .read-board {
    background: white !important;
    position: absolute;
    left:0;
    top:0;
    z-index: 9999999!important;
    overflow: visible !important;
    height: auto !important;
    min-height: auto !important;
    max-height: none !important;
  }

  #post {
    max-width: 100% !important;
    width: 100% !important;
    padding: 0 !important;
    margin: 0 !important;
    gap: 0 !important;
    overflow: visible !important;
    height: auto !important;
    min-height: auto !important;
    max-height: none !important;
    box-sizing: border-box !important;
  }

  /* ========== 첫 페이지 표지 스타일 ========== */
  #post .header {
    min-height: 90vh !important;
    height: 90vh !important;
    background: white !important;
    border-bottom: none !important;
    padding: 0 !important;
    margin: 0 !important;
    page-break-after: always !important;
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
    align-items: center !important;
    position: relative !important;
  }

  #post .header > .thumb {
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: 100% !important;
    object-fit: cover !important;
    display: block !important;
    filter: brightness(0.85);
  }

  #post .header > .cover {
    position: absolute !important;
    background: linear-gradient(to bottom, rgba(0,0,0,0.2), rgba(0,0,0,0.65)) !important;
    padding: 60px 40px !important;
    width: 100% !important;
    height: 100% !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    flex-direction: column !important;
    text-align: center !important;
    box-sizing: border-box !important;
  }

  #post .header > .cover > p.type {
    color: rgba(255,255,255,0.95) !important;
    font-size: 20px !important;
    margin-bottom: 30px !important;
    font-weight: 600 !important;
    text-transform: uppercase !important;
    letter-spacing: 4px !important;
    display: block !important;
  }

  #post .header > .cover > .index {
    height: auto !important;
    width: 100% !important;
    display: flex !important;
    justify-content: center !important;
  }

  #post .header > .cover > .index > h2 {
    color: #fff !important;
    font-size: 64px !important;
    line-height: 1.2 !important;
    overflow: visible !important;
    margin: 0 !important;
    word-break: keep-all !important;
    font-weight: 800 !important;
    letter-spacing: -2px !important;
    text-shadow: 0 6px 20px rgba(0,0,0,0.6) !important;
    max-width: 85% !important;
  }

  /* ========== 본문 콘텐츠 (2페이지부터) ========== */
  #post .content {
    width: 100% !important;
    max-width: 100% !important;
    height: auto !important;
    min-height: auto !important;
    max-height: none !important;
    overflow: visible !important;
    padding: 3cm 2.5cm 2.5cm 2.5cm !important;
    box-sizing: border-box !important;
  }

  #post .content > #editorjsView {
    max-width: 100% !important;
    color: #000 !important;
    overflow: visible !important;
    height: auto !important;
    min-height: auto !important;
    max-height: none !important;
  }

  /* EditorJS 블록 스타일 */
  .ce-block {
    color: #000 !important;
    page-break-inside: auto !important;
  }

  .ce-block__content,
  .ce-toolbar__content {
    max-width: 100% !important;
    width: 100% !important;
    color: #000 !important;
    overflow: visible !important;
    height: auto !important;
    max-height: none !important;
  }

  .codex-editor {
    overflow: visible !important;
    height: auto !important;
    max-height: none !important;
  }

  .codex-editor__redactor {
    overflow: visible !important;
    height: auto !important;
    max-height: none !important;
    padding-bottom: 0 !important;
  }

  .ce-paragraph {
    color: #1a1a1a !important;
    line-height: 1.8;
    font-size: 15px;
    margin: 14px 0;
    word-break: keep-all;
    text-align: justify;
  }

  .ce-header {
    color: #000 !important;
    padding: 20px 0 8px 0;
    font-weight: 700;
    letter-spacing: -0.3px;
    page-break-after: avoid;
  }

  .ce-header[data-level="1"] {
    font-size: 28px;
    margin-top: 30px;
  }

  .ce-header[data-level="2"] {
    font-size: 24px;
    margin-top: 25px;
  }

  .ce-header[data-level="3"] {
    font-size: 20px;
    margin-top: 20px;
  }

  /* 리스트 스타일 */
  .cdx-list {
    color: #1a1a1a !important;
    margin: 15px 0;
  }

  .cdx-list__item {
    color: #1a1a1a !important;
    line-height: 1.7;
    padding: 6px 0;
    font-size: 15px;
  }

  /* 이미지 처리 */
  .image-tool__image {
    max-width: 100%;
    page-break-inside: avoid;
    margin: 25px 0;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  }

  .image-tool__caption {
    color: #666 !important;
    font-size: 13px;
    text-align: center;
    margin-top: 8px;
    font-style: italic;
  }

  /* 첨부파일 스타일 */
  .cdx-attaches {
    background: #f8f8f8 !important;
    border: 1px solid #e0e0e0 !important;
    border-radius: 6px;
    padding: 12px;
    page-break-inside: avoid;
    margin: 15px 0;
  }

  .cdx-attaches__file-icon {
    display: inline-block;
  }

  .cdx-attaches__title {
    color: #1a1a1a !important;
    font-weight: 600;
  }

  .cdx-attaches__size {
    color: #666 !important;
  }

  /* 툴바 및 에디터 UI 숨김 */
  .ce-toolbar,
  .ce-inline-toolbar,
  .ce-conversion-toolbar,
  .ce-settings {
    display: none !important;
  }

  /* 링크 스타일 */
  a {
    color: #1a1a1a !important;
    text-decoration: underline;
  }

  /* 링크 URL 표시 */
  a[href]:after {
    content: " (" attr(href) ")";
    font-size: 0.85em;
    color: #666;
    word-break: break-all;
    font-weight: normal;
  }

  /* 페이지 설정 */
  @page {
    margin: 0;
    size: A4 portrait;
  }

  @page :first {
    margin: 0;
  }

  /* 페이지 나누기 방지 */
  h1, h2, h3, h4, h5, h6 {
    page-break-after: avoid;
    page-break-inside: avoid;
  }

  img {
    page-break-inside: avoid;
    page-break-after: auto;
  }

  /* 색상 강제 적용 (브라우저 인쇄 설정 무시) */
  * {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
}
</style>